module.exports = "/images/grey_TW.png?71c13d5bf2af358fa143fa24f2a4fa4e";